/* PagingOdmOsPlatformFeed.js */

const PagingFeed = require("../../../../lib/PagingFeed");

class PagingOdmOsPlatformFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startOdmOsPlatformsFeed(
            this._activeOrgId,
            this._filter,
            this._entityFields,
            this._sort,
            {
                skip: 0,
                limit: this._pageSize * 2,
            }
        );
    }

    _getDistinctValuesOfField(tenantId, field) {
        return this._EntityDef.loadOdmOsPlatformDistinctValues(tenantId, field);
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadOdmOsPlatformIdsForSelection(tenantId, selection);
    }

    getOdmOsPlatformEntitiesById(ids) {
        return this.getEntitiesById(ids);
    }

    getOdmOsPlatformEntitiesNameById(ids) {
        return this.getEntitiesValueByIdAsProm(ids, "name");
        // return this.getEntitiesNameById(ids);
    }

    getOdmOsPlatformEntityById(id) {
        return this.getEntityById(id);
    }
}

module.exports = PagingOdmOsPlatformFeed;
